/**
 * CaseStudiesSection Component
 * Landing page case studies showcasing results
 */

import { CASE_STUDIES } from "./constants";

export const CaseStudiesSection = () => {
  return (
    <section id="case-studies" className="py-20 px-6 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-tl from-primary/5 to-transparent"></div>
      <div className="container mx-auto max-w-6xl relative z-10">
        <h2 className="text-4xl font-bold text-center text-primary mb-4">
          Real Results, Real Growth
        </h2>
        <p className="text-center text-foreground/70 mb-12 max-w-xl mx-auto">
          Discover how brands are achieving remarkable results with MerchMidas.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {CASE_STUDIES.map((study, index) => (
            <div key={index} className="p-6 rounded-2xl glass">
              <div className="text-5xl font-bold text-primary mb-2">
                {study.metric}
              </div>
              <p className="text-foreground/60 mb-4">{study.description}</p>
              <p className="text-sm text-primary font-medium">{study.brand}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
